module.exports = __webpack_public_path__ + "static/media/tail-left.cfde6299.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tail-left.svg
// module id = 29
// module chunks = 0